// extracted by mini-css-extract-plugin
export default {"root":"footerNav-module--root--UQ4aG","active":"footerNav-module--active--z_C7n"};